'use strict';
var analysisViewTpl = require('../documentation/view.html');
var util = require('../../util/property-util');
var nocUtil = require('../../util/noc-util');
var arrayUtil = require('../../util/array-util');

module.exports = /*@ngInject*/ ["$scope", "$rootScope", "$filter", "$stateParams", "NgTableParams", "UrlRoutingFactory", "AuthenticationFactory", "trains", "TripOverviewFactory", "AdvancedQueryResourceService", "ProjectService", "SqiFactory", "CsvFactory", "words", "NmsConfigResourceService", "TrainCacheService", "TrainTypeService", "TrainMaintainerService", "ConfigurationStoreService", "TimeZoneFactory", "LocaleFactory", "$uibModal", function ($scope, $rootScope, $filter, $stateParams, NgTableParams, UrlRoutingFactory, AuthenticationFactory, trains, TripOverviewFactory, AdvancedQueryResourceService, ProjectService, SqiFactory, CsvFactory,
                           words, NmsConfigResourceService, TrainCacheService, TrainTypeService, TrainMaintainerService, ConfigurationStoreService, TimeZoneFactory, LocaleFactory, $uibModal) {
    
    $scope.maxToDateTime = new Date()
    $scope.tripId = $stateParams.tripId;
    $scope.myTime = new Date();
    $scope.query = {};
    $scope.query.trains = {};
    $scope.query.error = false;
    $scope.trips = [];
    $scope.statTitles = [];
    $scope.emptyResult = false;
    $scope.queryError = "";
    $scope.actionSuccess = "";
    $scope.actionFailure = "";

    $scope.invalidSqiValue = -999;
    $scope.isSearching = false;
    $scope.tripType = {
        name: 'all'
    };

    $scope.tabs = [
        {title: 'Dynamic Title 1', content: 'Dynamic content 1'},
        {title: 'Dynamic Title 2', content: 'Dynamic content 2', disabled: true}
    ];

    $scope.words = {};

    $scope.trains = arrayUtil.sortByOfficialId(trains);
    $scope.allSelector = {all: false};
    $scope.showEsa = false;

    $scope.selectedTab = 'statistics';

    $scope.isUserAdmin = false;
    $scope.isMaxPeriod = false;
    $scope.errorMessage = "";


    //$scope.tripsDashboard = "no search yet";

    var projectSlaConfig = undefined;
    var projectConfiguration = undefined;

    initProjects();
    initPage();

    function initPage() {
        TripOverviewFactory.clearList();
       $scope.words = words;

        var previousFrom = UrlRoutingFactory.getTimestamp("from");
        if (util.isDefined(previousFrom)) {
            $scope.query.from = nocUtil.toDate(previousFrom);
        }

        var previousTo = UrlRoutingFactory.getTimestamp("to");
        if (util.isDefined(previousTo)) {
            $scope.query.to = nocUtil.toDate(previousTo);
        }

        $scope.query.query = UrlRoutingFactory.get("query");
        $scope.tripType.name = nocUtil.parseStringToBoolean(UrlRoutingFactory.get("type"));

        if (!util.isDefined($scope.tripType.name)) {
            $scope.tripType.name = "main";
        }
        if (!util.isDefined($scope.query.from) || !util.isDefined($scope.query.to)) {
            // if either from or to is not defined, choose default period of 1 day
            lastDays(1);
        }

        if (!util.isDefined($scope.query.query)) {
            $scope.query.query = "";
        }

        var selectedTrainIds = UrlRoutingFactory.get("trainIds", true);
        TrainCacheService.setManually($scope.trains);

        // get the train types from the trains.
        $scope.trainTypeObjects = TrainTypeService.getTrainTypeObjects($scope.trains);

        $scope.customTrainTypeNames = TrainTypeService.getTrainTypeDisplayNameObjects($scope.trains);


        // get the selectedTrainTypes.
        var selectedTrainTypes = UrlRoutingFactory.get("trainTypes", true);

        // keeps track of selected trainTypes
        $scope.query.trainTypeData = [];

        // restore previous selected train types.
        if (util.isDefined(selectedTrainTypes)) {
            selectedTrainTypes.forEach(function (trainType) {
                // for every trainType String, look in trainTypes if it has a matching record.
                $scope.trainTypeObjects.some(function (trainTypeData) {
                    // should be done by reference: that's why we do it in such a stupid way :/
                    if (trainTypeData.code == trainType) {
                        $scope.query.trainTypeData.push(trainTypeData);
                        return true;
                    }

                    return false;
                });
            })
        }


        // get the train maintainers from the trains.
        $scope.trainMaintainerObjects = TrainMaintainerService.getTrainMaintainerObjects($scope.trains);

        // get the selectedMaintainers.
        var selectedTrainMaintainers = UrlRoutingFactory.get("trainMaintainers", true);

        // keeps track of selected trainMaintainers
        $scope.query.trainMaintainerData = [];

        // restore previous selected train maintainer.
        if (util.isDefined(selectedTrainMaintainers)) {
            selectedTrainMaintainers.forEach(function (trainMaintainer) {
                // for every trainMaintainer String, look in trainMaintainers if it has a matching record.
                $scope.trainMaintainerObjects.some(function (trainMaintainerData) {
                    // should be done by reference: that's why we do it in such a stupid way :/
                    if (trainMaintainerData.code == trainMaintainer) {
                        $scope.query.trainMaintainerData.push(trainMaintainerData);
                        return true;
                    }

                    return false;
                });
            })
        }

        $scope.query.trains = [];
        if (util.isDefined(selectedTrainIds)) {
            selectedTrainIds.forEach(function (trainId) {
                // important: the selected item must be a reference to an item from the model that is displayed in the view
                // containing the same data is not enough (for it to appear selected in the view)
                var foundTrain = TrainCacheService.getRelativeTrain(trainId);
                if (util.isDefined(foundTrain)) {
                    $scope.query.trains.push(foundTrain);
                }
            });
        }

        projectSlaConfig = SqiFactory.fetchProjectSpecificConfiguration($scope.selectedProject.id, function (configuration) {
            projectSlaConfig = configuration.sqiConfigurations;
            projectConfiguration = configuration;
            $scope.showEsa = util.isDefined(arrayUtil.getFirstInList(projectConfiguration.components, "name", "esa-report"));

        });

        // if all parameters are defined > execute find trips query
        if (util.isDefined($scope.query.trains) && $scope.query.trains.length !== 0 &&
            util.isDefined($scope.query.from) && util.isDefined($scope.query.to)) {
            findTrips(true);
        }

        $scope.isUserAdmin = AuthenticationFactory.isAdmin();
    }

    $scope.executeQuery = function () {
        findTrips(false);
    };

    $scope.validateTripFilter = function () {
        console.log("type: " + $scope.tripType);
    };


    $scope.state = $stateParams.overview;
    var searching = "Looking for trips";

    $scope.tableParams = new NgTableParams(
        {
            page: 1,
            count: 50,
            sorting: {'departure': "asc"}
        }, {
            counts: [],
            total: 1, // length of $scope.data
            getData: function (params) {
                var orderedData = params.sorting() ? $filter('orderBy')($scope.trips, params.orderBy()) : $scope.trips;
                params.total(orderedData.length);
                return orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count());
            },
            filterDelay: 0
        }
    );

    /**
     * Filter, called for every train and decides if the train should be shown according to trainTypes array.
     *
     * @param trainTypeObjects
     * @param trainMaintainerObjects
     * @returns {Function}
     */
    $scope.filterTrains = function (trainTypeObjects, trainMaintainerObjects) {
        return function (train) {
            return TrainTypeService.filterTrainByTypesFilter(train, trainTypeObjects) &&
                TrainMaintainerService.filterTrainByMaintainersFilter(train, trainMaintainerObjects);
        };
    };


    /**
     * clear the selected trains by setting the length to 0.
     * @param selectedTrains
     */
    $scope.clearTrains = function (selectedTrains) {
        selectedTrains.length = 0;
    };


    $scope.sortArrayField = function (array, property, index, sortBy, $event) {
        var newName = array + "[" + index + "]." + property;
        $scope.sort(newName, sortBy, $event);
    };

    $scope.sort = function (property, sortBy, $event) {
        var object;
        if ($event.shiftKey) {
            object = $scope.tableParams.sorting();
            object[property] = sortBy;
        } else {
            object = {};
            object[property] = sortBy;
        }
        $scope.tableParams.sorting(object);
        $scope.tableParams.reload();
    };

    $scope.findTrips = function (skipSave) {
        if (!$scope.query.error) {
            findTrips(skipSave);
            TripOverviewFactory.clearList();
            $scope.allSelector = {all: false};
        }
    };

    $scope.getSlaFullDescriptionByTitle = function (title) {
        var metaData = arrayUtil.getFirstInList(projectSlaConfig, "label", title);
        if (util.isDefined(metaData)) {
            return metaData.discription;
        }
        return title;
    };

    function findTrips(skipSave) {
        var from = $scope.query.from;
        var to = $scope.query.to;

        if (!skipSave) {
            UrlRoutingFactory.saveTimestamp("from", from);
            UrlRoutingFactory.saveTimestamp("to", to);
            UrlRoutingFactory.saveListOfProperties("trainIds", $scope.query.trains, "relativeId");
            UrlRoutingFactory.save("trainTypes", $scope.query.trainTypeData);
            UrlRoutingFactory.saveListOfProperties("trainMaintainers", $scope.query.trainMaintainerData, "code");
            UrlRoutingFactory.save("query", $scope.query.query);
            UrlRoutingFactory.save("type", $scope.tripType.name);
        }
        var trainIds = util.getListOfProperties($scope.query.trains, 'id');
        var query = $scope.query.query;

        $scope.statusMessage = searching;

        if (!hasValidCriteria($scope.query)) {
            return;
        } else {
            $scope.isSearching = true;
            $scope.emptyResult = false;
            $scope.queryError = "";
        }

        var start = TimeZoneFactory.dateInCurrentTimeZone(from).format();
        var end = TimeZoneFactory.dateInCurrentTimeZone(to).format();


        // call the services endpoint for the selected trains.
        $scope.words.valids.set("SERVICE_ID", null);
        var relativeIds = util.getListOfProperties($scope.query.trains, 'relativeId');
        AdvancedQueryResourceService.services().query({ projectId: $stateParams.projectId, trainIds: relativeIds }).$promise.then(function (data) {
            var serviceIds = [];
            data.forEach( function (serviceId) {
                if (util.isDefined(serviceId) && serviceIds.indexOf(serviceId) == -1) {
                    serviceIds.push(serviceId);
                    words.values.push(serviceId);
                }
            });
            words.valids.set("SERVICE_ID", serviceIds);
        })

        AdvancedQueryResourceService.trips().query({
            projectId: $scope.selectedProject.id,
            trainIds: trainIds,
            from: start,
            to: end,
            type: $scope.tripType.name,
            query: query
        }).$promise.then(function (data) {
                $scope.trips = data;
                $scope.emptyResult = $scope.trips.length === 0;
                // get the SQI configuration from the server.
                NmsConfigResourceService.requestConfig($scope.selectedProject.id).getSqis().$promise.then(function (projectSqiList) {
                    $scope.statTitles = [];
                    var averagePerSqi = new Map();

                    angular.forEach(projectSqiList, function (projectSqi) {
                        // fill up the label list for the ui.
                        $scope.statTitles.push(projectSqi);
                        // this map will hold a list of values and metadata per sqi id.
                        averagePerSqi.set(projectSqi.id, undefined);
                    });


                    angular.forEach($scope.trips, function (trip) {

                        prepareTripData(trip, null, projectSqiList, averagePerSqi);

                        angular.forEach(trip.subTrips, function (subTrip) {
                            prepareTripData(subTrip, trip, projectSqiList, averagePerSqi)
                        });

                    });

                    // calculate the mean of for each SQI id.
                    var metSqis = [];
                    console.log("averagePerSqi");
                    console.log(averagePerSqi);
                    averagePerSqi.forEach(function (averagedStatistic) {
                        if (util.isDefined(averagedStatistic)) {
                            averagedStatistic.value = averagedStatistic.values.mean();
                            averagedStatistic.cssClass = nocUtil.createSpecificsClass(averagedStatistic);
                            delete averagedStatistic.values;
                            metSqis.push(averagedStatistic);
                        }
                    });

                    $scope.kpiStatistics = metSqis;
                    if (util.isDefined($scope.trips)) {
                        $scope.tableParams.reload();
                        $scope.tableParams.page(1); //reset to first page
                    }
                    $scope.isSearching = false;
                    $scope.searchedForMainTripsOnly = containsMainTrips();
                    $scope.searchedForType = $scope.tripType.name;
                    $scope.searchedForDirectTripsOnly = isDirectTrip();


                }, function (response) {
                    if (response.hasOwnProperty('data')) {
                        $scope.queryError = "Query error: " + response.data.errorMessage;
                        $scope.isSearching = false;
                    }
                });
            }
        );

    }


    function prepareTripData(trip, parentTrip, projectSqiList, averagePerSqi) {
        var duration = trip.arrival - trip.departure;
        var hours = Math.floor(duration / 36e5);
        var mins = Math.floor((duration % 36e5) / 6e4);
        hours = hours < 10 ? "0" + hours : hours;
        mins = mins < 10 ? "0" + mins : mins;
        trip.duration = hours + ":" + mins;

        if (trip.mainTrainTrip) { // mainTrip
            trip.isExpanded = false;
            trip.hasSubTrips = util.isDefined(trip.subTrips) && trip.subTrips.length > 0;
            trip.parentTripID = 0;
            trip.sqiPrefix = "sqi-";
        } else { // subTrip
            if (parentTrip != null) {
                trip.parentTripID = parentTrip.id;
            }
            trip.sqiPrefix = "sqi-st-";
        }


        angular.forEach(trip.statistics, function (statistic) {
            // get specific metadata for the SQI id.
            var metaData = arrayUtil.getFirstInList(projectSqiList, 'id', statistic.sqiId);
            console.log("stat");
            console.log(statistic);
            console.log("meta");
            console.log(metaData);

            statistic = nocUtil.extendWithSQIMetaData(statistic, metaData, $scope.invalidSqiValue);

            if (util.isDefined(metaData)) {

                var averagedStatistic = averagePerSqi.get(statistic.sqiId);

                if (!util.isDefined(averagedStatistic)) {
                    if (util.isDefined(metaData)) {
                        averagedStatistic = {
                            "values": [],
                            "title": metaData.label,
                            "bad": metaData.badValue,
                            "good": metaData.goodValue,
                            "perfect": metaData.targetValue,
                            "reverse": metaData.reverse,
                            "id": metaData.id,
                            "shortDescription": metaData.shortDescription,
                            "description": metaData.description,
                            "mdDocumentation": metaData.mdDocumentation,
                            "unit": metaData.unit
                        }
                    }
                }

                if (isValidSqiValue(statistic.value)) {
                    // add current sqi value to the list of values of that SQI id.
                    averagedStatistic.values.push(statistic.value);
                    averagePerSqi.set(statistic.sqiId, averagedStatistic);
                } else {
                    // do not show any value on the screen.s
                    statistic.value = undefined;
                }
            }
        });
    }


    $scope.shouldDisplayTrip = function (trip) {

        if (!$scope.searchedForDirectTripsOnly && $scope.searchedForMainTripsOnly) {
            return trip.mainTrainTrip;
        }
        return true;
    };

    $scope.expandTrip = function (trip) {
        trip.isExpanded = !trip.isExpanded;
    };

    function containsMainTrips() {
        return $scope.tripType.name === "main" || $scope.tripType.name === "all" || $scope.tripType.name === "direct";
    }

    function isDirectTrip() {
        return $scope.searchedForType === "direct";
    }


    $scope.exportTrips = function () {
        if (util.isDefined($scope.trips) && $scope.trips.length > 0) {
            var csv = createCsvString($scope.trips);
            CsvFactory.download(csv, 'trip-export-' + $filter('tzdate')(new Date(), 'YYYY/MM/DD HH:mm') + ".csv");
        } else {

        }
    };

    var createCsvString = function (data) {
        var separator = LocaleFactory.getCurrentLocaleConfig().separator;
        var csvString = "";
        csvString += "Trip id" + separator;
        csvString += "Service id" + separator;
        csvString += "Official id" + separator;
        csvString += "Train id" + separator;
        csvString += "Trajectory" + separator;
        csvString += "Departure" + separator;
        csvString += "Arrival" + separator;
        csvString += "Duration (ms)" + separator;
        data[0].statistics.forEach(function (stat) {
            csvString += stat.title + separator
        });
        csvString += "\n";
        data.forEach(function (jsonObject) {
            csvString += jsonObject.id + separator;
            csvString += jsonObject.serviceId + separator;
            csvString += jsonObject.officialId + separator;
            csvString += jsonObject.trainId + separator;
            csvString += jsonObject.trajectory + separator;
            csvString += $filter('tzdate')(jsonObject.departure, 'YYYY/MM/DD HH:mm') + separator;
            csvString += $filter('tzdate')(jsonObject.arrival, 'YYYY/MM/DD HH:mm') + separator;
            csvString += (jsonObject.arrival - jsonObject.departure) + separator;
            jsonObject.statistics.forEach(function (stat) {
                csvString += LocaleFactory.formatCSVValue(stat.value) + separator
            });
            csvString += "\n";
        });
        return csvString;
    };

    function isValidSqiValue(value) {
        return value !== $scope.invalidSqiValue
    }

    $scope.createUrl = function (message) {
        return createCsvUrl(message, 1);
    };

    function hasValidCriteria(query) {
        if (util.isDefined(query)) {
            if (util.isDefined(query.trains)) {
                if (query.trains.length < 1) {
                    return false;
                }
            } else {
                return false;
            }
            if (!util.isDefined(query.from)) {
                return false;
            }
            if (!util.isDefined(query.to)) {
                return false;
            }

            if (!util.isDefined($scope.selectedProject)) {
                return false;
            }

        } else {
            return false;
        }
        return true;
    }

    $scope.createPercentileReport = function () {
        if (hasValidCriteria($scope.query)) {
            return createExportUrl("rest/export/sqi-percentile");
        }
    };

    function createExportUrl(url) {
        var trainIds = util.getListOfProperties($scope.query.trains, 'relativeId');
        return url + "?trainIds=" + trainIds + "&from=" + $scope.query.from.getTime() + "&to=" + $scope.query.to.getTime() + "&token=" + AuthenticationFactory.getUser().token + "&projectId=" + $scope.selectedProject.id;
    }

    $scope.dateOptions = {
        'year-format': "'yyyy'",
        'starting-day': 1
    };

    $scope.openFrom = function ($event) {
        $scope.openedTo = false;
        $event.preventDefault();
        $event.stopPropagation();
        $scope.openedFrom = true;
    };

    $scope.openTo = function ($event) {
        $scope.openedFrom = false;
        $event.preventDefault();
        $event.stopPropagation();
        $scope.openedTo = true;
    };

    $scope.lastDays = function (days) {
        lastDays(days);
    };

    function lastDays(days) {
        var period = nocUtil.createPeriodUpToNow(days);
        $scope.query.to = period.end;
        $scope.query.from = period.start;
    }


    $scope.skipFromDays = function (days) {
        $scope.query.from = new Date($scope.query.from.getTime() + ((days * 24 * 60 * 60 * 1000)));
    };

    $scope.skipToDays = function (days) {
        $scope.query.to = new Date($scope.query.to.getTime() + ((days * 24 * 60 * 60 * 1000)));
    };

    $scope.submitDisabled = function () {
        return $scope.query.trains === undefined || $scope.query.trains.length === 0;
    };

    $scope.addToSet = function (trip, alwaysSet) {

        $scope.actionFailure = "";

        if (alwaysSet === undefined) {
            if (util.isDefined(trip.inSet)) {
                trip.inSet = !trip.inSet;
            } else {
                trip.inSet = true;
            }
        }

        if (trip.inSet) { //inSet was false, now true
            TripOverviewFactory.addToList(trip.id, trip.trainName);
        } else {
            TripOverviewFactory.removeFromList(trip.id);
        }

        if (alwaysSet) {
            TripOverviewFactory.addToList(trip.id, trip.trainName);
        }
    };

    $scope.executeSelectedAction = function(tripRecalOption) {

        clearAlerts();

        var projectId = ProjectService.getSelectedProjectId();
        var from = TimeZoneFactory.formatWithTimeZone($scope.query.from, "YYYY-MM-DD");
        var to = TimeZoneFactory.formatWithTimeZone($scope.query.to, "YYYY-MM-DD");
        var trainIds = util.getListOfProperties($scope.query.trains, 'relativeId');

        switch (tripRecalOption) {

            // RECALCULATE SELECTED TRIPS
            case 1: recalculateTrips(); break;

            // RECALCULATE EXISTING TRIPS for selected period and/or selected trains
            case 2: recalculateTripsByTrainIds(projectId, from,  to, trainIds); break;

            // CALCULATE TRIPS ACCORDING TO THE SCHEDULE for selected period and/or selected trains
            case 3: calculateTripsBySchedule(projectId, from,  to, trainIds); break;

            // FETCH TRAIN SCHEDULE for current day or date (selected in 'From' date) and for selected trains
            case 4: fetchTrainSchedule(projectId, trainIds, from); break;
        }
    };

    $scope.recalculateTrip = (trip => {
        clearAlerts();
        recalculateTrips(trip)
    });

    function recalculateTrips(trip) {

        if ($scope.trips.length == 0) {
            showAlert(false, "There are no trips to select for recalculation");
            return;
        }

        var selectedTrips = [];
        if (trip) {
            selectedTrips.push(trip.id);
        } else {
            selectedTrips = TripOverviewFactory.getList();
        }
        if(selectedTrips.length == 0) {
            showAlert(false, "Please select at least a trip");
            return;
        }

        var projectId = $scope.selectedProject.id;
        AdvancedQueryResourceService.recalculateTrips().save({
            projectId: projectId,
            tripIds: selectedTrips
        }, {}).$promise.then(function (response) {
            if (response.success) {
                showAlert(true, response.message);
            } else {
                showAlert(false, response.message);
            }
        }, function() {
            showAlert(false, "Error occurred while putting Trips to recalculate");
        });
    }

    function showAlert(success, message) {

        clearAlerts();
        success ? $scope.actionSuccess=message : $scope.actionFailure=message;
    }

    function clearAlerts() {
        $scope.actionSuccess = "";
        $scope.actionFailure = "";
    }

    function recalculateTripsByTrainIds(projectId, from,  to, trainIds) {

        if ($scope.query.to <= $scope.query.from) {
            showAlert(false, "To date is before From date");
            return;
        }

        AdvancedQueryResourceService.recalculateTripsByTrainIds().save({
            projectId: projectId,
            from: from,
            to: to,
            trainIds: (trainIds? trainIds: null)
        }, {}).$promise.then(function (response) {
            if (response.success) {
                showAlert(true, response.message);
            } else {
                showAlert(false, response.message);
            }
        }, function() {
            showAlert(false, "Error occurred while putting Existing trips to recalculate");
        });
    }

    function calculateTripsBySchedule(projectId, from,  to, trainIds) {

        if ($scope.query.to <= $scope.query.from) {
            showAlert(false, "To date is before From date");
            return;
        }

        AdvancedQueryResourceService.calculateTripsBySchedule().save({
            projectId: projectId,
            from: from,
            to: to,
            trainIds: (trainIds? trainIds: null)
        }, {}).$promise.then(function (response) {
            if (response.success) {
                showAlert(true, response.message);
            } else {
                showAlert(false, response.message);
            }
        }, function() {
            showAlert(false, "Error occurred while putting trips(having existing train schedule) for calculation");
        });
    }

    function fetchTrainSchedule(projectId, trainIds, date) {
        AdvancedQueryResourceService.fetchTrainSchedule().save({
            projectId: projectId,
            trainIds: (trainIds? trainIds: null),
            date: (date? date: null)
        }, {}).$promise.then(function (response) {
            if (response.success) {
                showAlert(true, response.message);
            } else {
                showAlert(false, response.message);
            }
        }, function() {
            showAlert(false, "Error occurred while scheduling a background process to fetch train schedule");
        });
    }

    $scope.selectAll = function (all) {
        if (all) { //all was false, now true
            $scope.trips.forEach(function (trip) {
                trip.inSet = true;
                TripOverviewFactory.addToList(trip.id, trip.trainName);
            });
        } else {
            $scope.trips.forEach(function (trip) {
                trip.inSet = false;
                TripOverviewFactory.removeFromList(trip.id);
            });
        }
    };

    $scope.openDocumentation = function (sla) {
        $uibModal.open({
            template: analysisViewTpl,
            controller: "DocumentationController as vm",
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
            resolve: {
                markupPageSource: function () {
                    return {
                        'file': sla.mdDocumentation
                    };
                }
            }
        });
    };

    function initProjects() {
        var selectedProject = $rootScope.selectedProject;
        // possible that selected project is not allowed to be shown.
        if (util.isDefined(selectedProject)) {
            $scope.selectedProject = selectedProject;

            $scope.trips = [];
            $scope.isSearching = false;
        }
    }

    function periodDiff() {
        const diff = $scope.query.to.getTime() - $scope.query.from.getTime();

        // To calculate the no. of days between two dates
        $scope.diffInDays = Math.round(diff / (1000 * 3600 * 24));
    }

    $scope.onFromDateChange = (date) => {
        $scope.query.from = date;
        $scope.$apply()
        $scope.$digest()
        onDateChange();
    }

    $scope.onToDateChange = (date) => {
        $scope.query.to = date;
        $scope.$apply()
        $scope.$digest()
        onDateChange();
    }

    function onDateChange() {
        $scope.isMaxPeriod = false;
        projectConfiguration = ConfigurationStoreService.getProjectConfiguration( $scope.selectedProject.id);

        if(projectConfiguration && projectConfiguration.periodRange && projectConfiguration.periodRange.tripOverviewRange) {
            periodDiff();
            if ($scope.diffInDays > projectConfiguration.periodRange.tripOverviewRange) {
                $scope.isMaxPeriod = true;
                this.errorMessage = 'Period Range must not exceed ' + projectConfiguration.periodRange.tripOverviewRange + ' days';
            }
        }
    }
}];
